export default __webpack_public_path__ + "static/media/euroMap.8bd9b139.PNG";